import axiosInstance from "@/api/axiosInstance";
import {
  CompleteEventRegistrationRequest,
  CompleteEventRegistrationResponse,
} from "./types";

export const completeEventRegistration = async (
  requestData: CompleteEventRegistrationRequest,
): Promise<CompleteEventRegistrationResponse> => {
  const response = await axiosInstance.post<CompleteEventRegistrationResponse>(
    "/api/private/v2/event-registrations/complete",
    requestData,
  );

  return response.data;
};
